module.exports = __webpack_public_path__ + "static/media/cafe24-main-sm.37b68276.png";